import { HostFamilyPriceTypeEnum } from '../../types/enums/ol/host-family-price-type.enum'
import { OLHostFamilyPricePerNightFilters } from '../../types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'

export const transformOlHostFamilyPriceFiltersToUrl = (
  filters?: OLHostFamilyPricePerNightFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.products && filters.products.length > 0)
    searchParams.set('products', filters.products.join(','))
  if (filters.periods && filters.periods.length > 0)
    searchParams.set('periods', filters.periods.join(','))
  if (filters.appliedToHost) searchParams.set('appliedToHost', filters.appliedToHost)
  if (filters.year) searchParams.set('year', filters.year.toString())

  return searchParams.toString()
}

export const transformUrlToOlHostFamilyPriceFilters = (
  searchParams: URLSearchParams
): OLHostFamilyPricePerNightFilters => {
  const filters: OLHostFamilyPricePerNightFilters = {}

  const products = searchParams.get('products')
  if (products) filters.products = products.split(',')

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',')

  const appliedToHost = searchParams.get('appliedToHost')
  if (appliedToHost) filters.appliedToHost = appliedToHost as HostFamilyPriceTypeEnum

  const year = searchParams.get('year')
  if (year) filters.year = +year

  return filters
}
